import React,{useEffect,useState} from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
//import TableContainer from '@mui/material/TableContainer';
//import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Title from './Title';
import Toast from './Toast';
import Ajax from './Ajax';
import Loading from './Loading';
import SuspendedSuccess from './SuspendedSusccess';
import {Inc,Owner,OwnerParam} from './Inc';

interface SuspendedProps {
	owner: Owner,
	param: OwnerParam,
}

const Suspended = (props:SuspendedProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        profile: Inc.defaultOwnerProfile(),
        isLoading:true,
		isExtended:false,
		toast:'',
    });
	//const [toast,setToast] = useState('');
    const load = ()=>{
		setStates({...states,isLoading:true});
		Ajax.send("profile/get",{},(res:any)=>{
			if( res.ok ){
				setStates({...states,"isLoading":false,"profile":Inc.convOwnerProfile(res.profile)})
			}
		});
    }
	const unlock = ()=>{
		setStates({...states,isLoading:true});
		Ajax.send("main/extend",{owner_id:props.owner.owner_id},(res:any)=>{
			if( res.ok ){
				setStates({...states,isLoading:false,isExtended:true});
			} else {
				setStates({...states,isLoading:false,toast:'一時停止を解除できませんでした'});
			}
		});
	}
	const closeToast = ()=>{
		setStates({...states,toast:''});
	}
    useEffect( ()=>{
        window.scrollTo(0,0);
        if( props.owner.owner_id>0 ){
			load();
        } else {
            //setStates({...states,"isLoading":false});
        }
    } ,[props.owner.owner_id]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

	let kijun = new Date();
	kijun.setFullYear(kijun.getFullYear() - 2);
	kijun.setHours(0);
	kijun.setMinutes(0);
	kijun.setSeconds(0);
	kijun.setMilliseconds(0);

	let kijunString = String(kijun.getFullYear())+"/";
	if( kijun.getMonth()<9 ){
		kijunString += '0';
	}
	kijunString += String(kijun.getMonth()+1)+"/";
	if( kijun.getDate()<10 ){
		kijunString += '0';
	}
	kijunString += String(kijun.getDate());

	let last_consign_ng = false;
	let last_sale_ng = false;
	let extended_ng = false;

	if( states.profile.last_consign!=='なし' ){
		const dt1 = new Date(states.profile.last_consign);
		if( dt1.getTime()<kijun.getTime() ){
			last_consign_ng = true;
		}
	}
	if( states.profile.last_sale!=='なし' ){
		const dt2 = new Date(states.profile.last_sale);
		if( dt2.getTime()<kijun.getTime() ){
			//console.log(dt2.getTime());
			//console.log(kijun.getTime());
			last_sale_ng = true;
		}
	}
	let extended = props.param.prev_extended;
	if( extended!=='' ){
		const sp = extended.split(" ");
		extended = sp[0];
		const dt3 = new Date(extended);
		if( dt3.getTime()<kijun.getTime() ){
			extended_ng = true;
		}
	} else {
		extended = 'なし';
	}

	
    return (
        <div id="suspended" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
				{props.param.aborted==="" ? (
				<>
                <Title text={"このプロフィールは一時停止中です"} icon="suspended"/>
				<div className={classes.section} style={{marginBottom:'2em'}}>
					納品および商品の売上がないまま２年間が過ぎたプロフィールは「一時停止」となります。<br/>
					一時停止中は作品も作家プロフィールページも非公開になります。またSideBの各種機能もご利用いただけません。<br/>
					{props.param.aborted==='' && 
					<div style={{marginTop:'0.5em'}}>取り扱いを再開するには「一時停止の解除」をしてください。</div>
					}
				</div>
				<div className={classes.section} style={{marginBottom:'3em',textAlign:'center'}}>
					<Button variant="contained" color="primary" startIcon={<LockOpenIcon/>} onClick={unlock}>一時停止の解除</Button>
				</div>
				</>
				):(
				<>
                <Title text={"このプロフィールは契約終了です"} icon="closed"/>
				<div className={classes.section} style={{marginBottom:'2em'}}>
					「一時停止」のまま6ヶ月が経過したため、このプロフィールは「契約終了」となりました。<br/>
				</div>
				</>
				)}
				<div className={classes.section}>
					<Divider/>
					<Table aria-label="simple table">
						<TableBody>
							<TableRow>
								<TableCell>取り扱い開始日</TableCell>
								<TableCell align="right">{states.profile.start_date}</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>最終納品日 <span style={{color:'brown'}}>※1</span></TableCell>
								<TableCell align="right">
									<Stack direction="row" alignItems="center" justifyContent="flex-end">
										{states.profile.last_consign!=='なし' && last_consign_ng && <CloseIcon style={{color:'RED'}}/>}
										{states.profile.last_consign!=='なし' && !last_consign_ng && <CheckIcon style={{color:'GREEN'}}/>}
										{states.profile.last_consign}
									</Stack>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>最終売上日 <span style={{color:'brown'}}>※2</span></TableCell>
								<TableCell align="right">
									<Stack direction="row" alignItems="center" justifyContent="flex-end">
										{states.profile.last_sale!=='なし' && last_sale_ng && <CloseIcon style={{color:'RED'}}/>}
										{states.profile.last_sale!=='なし' && !last_sale_ng && <CheckIcon style={{color:'GREEN'}}/>}
										{states.profile.last_sale}
									</Stack>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>前回の一時停止解除日 <span style={{color:'brown'}}>※3</span></TableCell>
								<TableCell>
									<Stack direction="row" alignItems="center" justifyContent="flex-end">
										{extended!=='なし' && extended_ng && <CloseIcon style={{color:'RED'}}/>}
										{extended!=='なし' && !extended_ng && <CheckIcon style={{color:'GREEN'}}/>}
										{extended}
									</Stack>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>一時停止日</TableCell>
								<TableCell align="right">
									{props.param.suspended}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>一時停止の解除期限</TableCell>
								<TableCell align="right">
									{props.param.deadline}
								</TableCell>
							</TableRow>
							{props.param.aborted!=="" &&
							<TableRow>
								<TableCell>契約終了日</TableCell>
								<TableCell align="right">
									{props.param.aborted}
								</TableCell>
							</TableRow>
							}
						</TableBody>
					</Table>
					<div style={{fontSize:'90%',padding:'1em',marginTop:'1em',backgroundColor:'#F5F5F5'}}>
						・※1、※2、※3のすべてが2年前（{kijunString}）より古い場合に「一時停止」となります<br/>
						・<span style={{backgroundColor:'red',color:'white',padding:'0.1em 0.5em',borderRadius:'0.5em',marginRight:'0.5em'}}>重要</span>「一時停止」のまま6ヶ月が経過した場合、ご利用継続の意思がないものとして自動的に「契約終了」となります<br/>
						・<span style={{backgroundColor:'red',color:'white',padding:'0.1em 0.5em',borderRadius:'0.5em',marginRight:'0.5em'}}>重要</span>商品の引取や売上残高の支払申請は「契約終了」になる前に「一時停止の解除」をしてSideBで手続きを行ってください<br/>
						・解除してから2年間は再び一時停止になることはありません<br/>
						・詳しくはSideB利用規約の[8]委託継続の意思確認をご確認ください（ログアウトすればご覧いただけます）<br/>
					</div>
				</div>
            </Paper>
			<SuspendedSuccess isOpen={states.isExtended}/>
			<Toast mes={states.toast} close={closeToast}/>
        </div>
    )
}

export default Suspended;